import React, { Component } from "react";
import _ from "lodash";
import Address from "../containers/Address.js";
import Dialog from "@material-ui/core/Dialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import locales from "../../../_constants/locales";
import StyledButtonCancel from "../../../components/StyledButtonCancel.jsx";
import StyledButton from "../../../components/StyledButton.jsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore.js";
import "../styles/AddressUpdateWindow.css";

class AddressUpdateWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedReplacementAddress: null,
            updatedReturnAddress: null,
            isAddressSameChecked: false,
            isReturnAddressAccordionOpen: false
        };
    }

    componentWillMount() {
        this.setState({
            updatedReturnAddress: JSON.parse(JSON.stringify(this.props.returnAddress)),
            updatedReplacementAddress: JSON.parse(JSON.stringify(this.props.replacementAddress))
        });
    }

    componentDidMount() {
        if (
            JSON.stringify(this.state.updatedReturnAddress) === JSON.stringify(this.state.updatedReplacementAddress) &&
            this.state.isAddressSameChecked === false
        ) {
            this.setState({
                isAddressSameChecked: true
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if (
        //     JSON.stringify(this.state.updatedReplacementAddress) !== JSON.stringify(prevState.updatedReplacementAddress) &&
        //     this.state.isAddressSameChecked === true
        // ) {
        //     this.setState({
        //         updatedReturnAddress: { ...this.state.updatedReplacementAddress }
        //     });
        // } else if (
        //     JSON.stringify(this.state.updatedReturnAddress) !== JSON.stringify(prevState.updatedReturnAddress) &&
        //     JSON.stringify(this.state.updatedReturnAddress) !== JSON.stringify(this.state.updatedReplacementAddress) &&
        //     this.state.isAddressSameChecked === true
        // ) {
        //     this.setState({
        //         isAddressSameChecked: false
        //     });
        // }

        if (this.props.ticketUpdating === false && prevProps.ticketUpdating === true) {
            this.setState({
                updatedReplacementAddress: { ...this.props.replacementAddress }
            });
        }

        if (this.state.isAddressSameChecked === false && prevState.isAddressSameChecked === true) {
            this.setState({
                isReturnAddressAccordionOpen: true
            });
        }

        if (this.props.open === true && prevProps.open === false) {
            this.reset();
        }
    }

    handleSubmitClick() {
        this.props.handleSubmit(this.state.updatedReplacementAddress, this.state.updatedReturnAddress);
    }

    isSubmitButtonEnabled() {
        return (
            !this.props.ticketUpdating &&
            (JSON.stringify(this.state.updatedReturnAddress) !== JSON.stringify(this.props.returnAddress) ||
                JSON.stringify(this.state.updatedReplacementAddress) !== JSON.stringify(this.props.replacementAddress))
        );
    }

    handleChange = event => {
        if (event.target.name === "isAddressSameChecked" && event.target.checked === true) {
            this.setState({
                [event.target.name]: event.target.checked,
                updatedReturnAddress: { ...this.state.updatedReplacementAddress }
            });
        } else {
            this.setState({ [event.target.name]: event.target.checked });
        }
    };

    handleReturnAddressChange = event => {
        this.setState({
            updatedReturnAddress: { ...this.state.updatedReturnAddress, [event.target.name]: event.target.value }
        });
    };

    handleReplacementAddressChange = event => {
        this.setState({
            updatedReplacementAddress: { ...this.state.updatedReplacementAddress, [event.target.name]: event.target.value },
            updatedReturnAddress: { ...this.state.updatedReplacementAddress, [event.target.name]: event.target.value }
        });
    };

    handleCancelClick() {
        this.props.handleCancelClick();
    }

    reset() {
        this.setState({
            updatedReturnAddress: JSON.parse(JSON.stringify(this.props.returnAddress)),
            updatedReplacementAddress: JSON.parse(JSON.stringify(this.props.replacementAddress))
        });
    }

    handeAccordionExpansionChange(name) {
        this.setState({ [name]: !this.state[name] });
    }

    render() {
        return (
            <Dialog open={this.props.open} className="address-update-dialog" onClose={this.reset.bind(this)} fullWidth={true}>
                <div className="flex layout vertical scroll address-update-window">
                    <div className="section inner">
                        <div className="section-header">
                            <div className="layout horizontal center title-row">
                                <h2 className="title">{locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.TITLE}</h2>
                            </div>
                        </div>
                        <div className="section-body">
                            <Address address={this.state.updatedReplacementAddress} handleChange={this.handleReplacementAddressChange.bind(this)} />
                        </div>
                        {/* disabled for phase 1 */}
                        {/* <div className="section-footer">
                            <FormControlLabel
                                className="custom-form-control-label"
                                control={
                                    <Checkbox
                                        checked={this.state.isAddressSameChecked}
                                        onChange={this.handleChange.bind(this)}
                                        name="isAddressSameChecked"
                                        color="primary"
                                    />
                                }
                                label="Return address is the same"
                            />
                        </div> */}
                    </div>

                    {/* disabled for phase 1 */}
                    {/* <Accordion
                        expanded={this.state.isReturnAddressAccordionOpen}
                        onChange={this.handeAccordionExpansionChange.bind(this, "isReturnAddressAccordionOpen")}
                        className="section address-accordion-section"
                        style={{ margin: "0px 0px 10px" }}
                    >
                        <AccordionSummary id="return-from-address-id" className="custom-accordion-panel-summary" expandIcon={<ExpandMoreIcon />}>
                            <div className="section-header">
                                <div className="layout horizontal center title-row">
                                    <span className="title">{locales[this.props.language.code].TICKET_CONFIRMATION.RETURN_ADDRESS.TITLE}</span>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className="custom-accordion-panel-details">
                            <div className="flex layout vertical">
                                <div>
                                    <Address address={this.state.updatedReturnAddress} handleChange={this.handleReturnAddressChange.bind(this)} />
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion> */}

                    {/* disabled for phase 1 */}
                    {/* <Accordion
                        expanded={this.state.isReturnAddressAccordionOpen}
                        onChange={this.handeAccordionExpansionChange.bind(this, "isReturnAddressAccordionOpen")}
                        className="section"
                        style={{ margin: "0px 0px 10px" }}
                    >
                        <AccordionSummary id="return-from-address-id" className="custom-accordion-panel-summary" expandIcon={<ExpandMoreIcon />}>
                            <span className="title">{locales[this.props.language.code].TICKET_CONFIRMATION.RETURN_ADDRESS.TITLE}</span>
                        </AccordionSummary>
                        <AccordionDetails className="custom-accordion-panel-details">
                            <div className="flex layout vertical">
                                <div>
                                    <Address address={this.state.updatedReturnAddress} handleChange={this.handleReturnAddressChange.bind(this)} />
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion> */}
                    <div className="footer layout horizontal end-justified">
                        <StyledButtonCancel onClick={this.handleCancelClick.bind(this)} variant="contained">
                            {locales[this.props.language.code].BUTTON.CANCEL.LABEL}
                        </StyledButtonCancel>
                        <StyledButton disabled={!this.isSubmitButtonEnabled()} onClick={this.handleSubmitClick.bind(this)} variant="contained">
                            {locales[this.props.language.code].BUTTON.SUBMIT.LABEL}
                            {this.props.ticketUpdating && <CircularProgress className="button-progress" size={16} thickness={4} />}
                        </StyledButton>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default AddressUpdateWindow;
